export function numberWithCommas(x: number): string {
  return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
}
export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

export const phoneMask = (value: number): string => {
  let _value = value.toString();
  var x: any = _value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  _value = !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
  return _value;
};

// export const optionStatus = [
//   { name: "New", code: "New" },
//   { name: "In Contract", code: "In Contract" },
//   { name: "Sold", code: "Sold" },
//   { name: "Hot Property", code: "Hot Property" },
//   { name: "Pending", code: "Pending" },
//   { name: "Ending Soon", code: "Ending Soon" }
// ];

// export const optionOffMarket = [
//   { name: "Yes", code: "Yes" },
//   { name: "No", code: "No" }
// ];

// export const optionSales = [
//   { name: "FCFS", code: "FCFS" },
//   { name: "Showing", code: "Showing" },
//   { name: "Site Unseen", code: "Site Unseen" },
//   { name: "Offers Due", code: "Offer Due" }
// ];

// export const optionVacant = [
//   { name: "Vacant", code: "Vacant" },
//   { name: "Occupied", code: "Occupied" },
//   { name: "Squatter", code: "Squatter" },
//   { name: "TIP", code: "TIP" },
//   { name: "SIP", code: "SIP" }
// ];
// export const optionDelivery = [
//   { name: "Delivered Vacant", code: "Delivered Vacant" },
//   { name: "Delivered occupied", code: "Delivered occupied" }
// ];
// export const options = [
//   { name: "CA", code: "CA" },
//   { name: "TX", code: "TX" }
// ];
